import * as yup from 'yup';

import { RoomHistory } from 'models/index';

import { endpoint, EndpointError } from '../endpoint';
import { ValidationShape } from '../validation';

export type SetParams = Omit<RoomHistory.Model, 'approvalRegulations'>;
export type SetResult = { uid: RoomHistory.Model['uid'] };
export type SetError = EndpointError;

const VALIDATION_ERROR = {
  REQUIRED_UID: 'UID נדרש',
  REQUIRED_ROOM_ID: 'זיהוי חדר נדרש',
};

export const setParamsSchema = yup.object().shape({
  uid: yup.string().required(VALIDATION_ERROR.REQUIRED_UID),
  roomId: yup.string().required(VALIDATION_ERROR.REQUIRED_ROOM_ID),
} as unknown as ValidationShape<SetParams>);

export const setListenerData = endpoint<SetParams, SetResult, SetError>({
  method: 'POST',
  url: () => `/room-history/set-listener-data`,
});
